import Vue from 'vue'
import VueRouter from 'vue-router'

import DefaultLayout from '@/layout/DefaultLayout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: DefaultLayout,
    redirect: { name: 'admin' },
    children: [
      {
        path: 'admin/cancel',
        name: 'admin.cancel',
        component: () =>
          import(
            /* webpackChunkName: "admin.cancel" */ '@/pages/Cancel/index.vue'
          )
      },
      {
        path: 'admin/delete-action-items',
        name: 'admin.delete',
        component: () =>
          import(
            /* webpackChunkName: "admin.delete" */ '@/pages/Delete/index.vue'
          )
      },
      {
        path: 'admin',
        name: 'admin',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/pages/Admin/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
